import demo from "../../../../assets/videos/blogs/dialog-lightbox/demo.mp4";
import * as React from 'react';
export default {
  demo,
  React
};